import React from 'react';
import PropTypes from 'prop-types';
import {debounce} from 'lodash';

export const ResponsiveLayout = props => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 768; // tablet breakpoint
  const { MobileComponent = (<div />), DesktopComponent = (<div />), ...others } = props;

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', debounce(handleWindowResize, 300));

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return width <= breakpoint ? <MobileComponent {...others} /> : <DesktopComponent {...others} />;
};

ResponsiveLayout.propTypes = {
  mobileComponent: PropTypes.func,
  desktopComponent: PropTypes.func
};
